import axios, { ENDPOINT } from '../../../utils/httpClient'
import { getPaylogServiceFees } from '../../../services/paylogConfig'

export const getTranscripts = (allOptions) => {
    return axios.get(`${ENDPOINT}/requests?${allOptions.toString()}`)
}

export const getMerchant = async (org) => {
    const {
        data: { merchant_id },
    } = await axios.get(`${ENDPOINT}/merchants?institution=${org}`)

    return merchant_id
}

export const getServices = async (org) => {
    // Check if paylog is configured
    const stored = localStorage.getItem('paylog_configured')
    const isPaylogConfigured = stored !== null ? JSON.parse(stored) === true : false

    if (isPaylogConfigured) {
        // If paylog is configured, fetch from paylog endpoint
        try {
            const paylogData = await getPaylogServiceFees(org)
            // Transform paylog service fees to match the expected format
            const services = paylogData.serviceFees?.map((fee) => ({
                service_type_id: fee.id.toString(),
                merchant_id: paylogData.paylog_id,
                service_type: fee.name.toUpperCase(),
                // Store the full fee object for later use
                _paylogFee: fee,
            })) || []
            return { data: services }
        } catch (error) {
            console.error('Error fetching paylog services, falling back to regular services:', error)
            // Fallback to regular service types if paylog fetch fails
            const results = await getMerchant(org).then((id) => {
                return axios.get(`${ENDPOINT}/service-types?merchant=${id}`)
            })
            return results
        }
    } else {
        // Use regular service types endpoint
        const results = await getMerchant(org).then((id) => {
            return axios.get(`${ENDPOINT}/service-types?merchant=${id}`)
        })
        return results
    }
}
